import { z } from 'zod';

import { Ulid } from './common.js';

export const LeadComment = z.object({
  id: Ulid,
  leadId: Ulid,
  authorUserId: Ulid,
  parentCommentId: Ulid.nullable(),
  body: z.string().min(1).max(10_000),
  editedAt: z.string().datetime().nullable(),
  deletedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type LeadComment = z.infer<typeof LeadComment>;

export const LeadCommentCreate = z.object({
  body: z.string().min(1).max(10_000),
  parentCommentId: Ulid.nullable().optional(),
});
export type LeadCommentCreate = z.infer<typeof LeadCommentCreate>;

export const LeadCommentUpdate = z.object({
  body: z.string().min(1).max(10_000),
});
export type LeadCommentUpdate = z.infer<typeof LeadCommentUpdate>;
